module.exports = __webpack_public_path__ + "blue.jpg?72ae5e17ec9b4000f4c8b69f7dd33803";